module.exports = __webpack_public_path__ + "img/courseEmpty.538dc33d.png";